import { Fragment } from 'react'
import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { EmptyState, type IColumn, Table, Tooltip } from 'shared/ui'
import { numberFormat } from 'shared/lib'
import { ChatbotRoutes } from 'pages/chatbot'
import { useChatbotListContext } from 'pages/chatbot/context'
import { ChatbotStatusBadge } from 'pages/chatbot/ui/ChatbotStatus'

import styles from './styles.module.scss'
import { type IChatbotRow, useRowsWithActions } from '../hooks/useRowsWithActions'

const COLUMNS: IColumn<IChatbotRow>[] = [
  {
    field: 'name',
    name: 'Name',
    minWidth: '145px',
    maxWidth: '245px',
    renderRowCell: ({ payload }) => payload.name,
  },
  {
    field: 'status',
    name: 'Status',
    minWidth: '120px',
    maxWidth: '260px',
    renderRowCell: ({ payload }) => (
      <Tooltip label={payload.isInvalid && 'Suspicious content detected'} placement={'top'}>
        <ChatbotStatusBadge status={payload.status} />
      </Tooltip>
    ),
  },
  {
    field: 'totalContacts',
    name: 'Started',
    minWidth: '120px',
    maxWidth: '260px',
    renderRowCell: ({ payload }) => numberFormat({ value: payload.totalContacts }),
  },
  {
    field: 'fallbackContacts',
    name: 'Abandoned',
    minWidth: '120px',
    maxWidth: '260px',
    renderRowCell: ({ payload }) => numberFormat({ value: payload.fallbackContacts }),
  },
  {
    field: 'completedContacts',
    name: 'Completed',
    minWidth: '120px',
    maxWidth: '260px',
    renderRowCell: ({ payload }) => numberFormat({ value: payload.completedContacts }),
  },
  {
    field: 'terminatedContacts',
    name: 'Stopped by user',
    minWidth: '120px',
    maxWidth: '260px',
    renderRowCell: ({ payload }) => numberFormat({ value: payload.terminatedContacts }),
  },
]

export const TextingTable = observer(() => {
  const navigate = useNavigate()
  const { page, limit, total, noData, loading, loadingScheduled, changePaging } =
    useChatbotListContext()

  const rows = useRowsWithActions()

  if (noData) return <EmptyState text='No results found' />

  return (
    <section className={styles.table}>
      <Table
        ariaLabel={'ChatbotListTable'}
        columns={COLUMNS}
        rows={rows}
        pinnedColumnNames={['name']}
        initPage={page}
        limit={limit}
        rightHeaderContent={<Fragment />}
        rowsCount={total}
        onChangePagination={changePaging}
        startPaginationSize={10}
        isLoading={loading || loadingScheduled}
        onRowClick={({ id }) => navigate(`/${ChatbotRoutes.root}/${id}/${ChatbotRoutes.analytic}`)}
      />
    </section>
  )
})
